var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.94 69.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.89 50.76a12 12 0 0 1-5.31-9.95c0-14.13 17-13.48 17-13.48v-7.77l18 13.49-18 13.31v-6.53c-7.58 0-11.69 3.64-11.69 10.93"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.97,
    cy: 34.97,
    r: 33.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c030ed2a740e80f9c6f4d7cd86685f7f.svg";
export { ForwardRef as ReactComponent };